import { useSelector } from 'react-redux';
import { getArray } from '../../utils/typeUtils';

export default function useRestaurantOptions() {
  const restaurantOptions = useSelector(state => state.login.restaurantOptions);
  return getArray(restaurantOptions);
}
